/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { useLocation, useNavigate } from 'react-router-dom';
import moment from "helpers/moment";

/* Helpers, constants, custom methods, internal libraries */
import { useReportsService  } from "../../../../services/reportsService";
import { useAnalytics } from "../../../../hooks/useAnalytics";
import { AIRLINES, PAGE_TITLES } from "../../../../constants/appConstants";
import { useHasPermission } from "../../../../hooks/useHasPermission";
import { usePowerBiService } from '../../../../services/powerBiService';

/* Components */
import MileageGrid from "./mileageGrid";
import MileageFilters from "./mileageFilters";
import PowerBi from "../../../powerBi";
import { useUserContext } from "../../../../contexts/userContext";

/* Styles */
import styles from "./styles.js"



const MileageTab = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const location = useLocation();
  const navigate = useNavigate();
  const { initAnalytics } = useAnalytics();
  const userDetails = useUserContext();
  const { checkPermission } = useHasPermission();
  const companyEntityId = userDetails?.userInfo?.companyInfo?.companyEntityId;

  const { powerBiConfig, getPowerBiConfig } = usePowerBiService()

  const [gridOptions, setGridOptions] = useState(() => {
    const initialPage = location.pathname.includes('/mileage')
      ? new URLSearchParams(location.search).get('page') || 1
      : 1;
    return {
      page: +initialPage,
      travelStartDate: moment().startOf('year').format("YYYY-MM-DD"),
      travelEndDate: moment().format("YYYY-MM-DD")
    };
  });
  useEffect(() => {
    (async () => {
      await getPowerBiConfig(companyEntityId);
    })();
  }, []);

  const { mileageResponse, getMileageList } = useReportsService();

  const enableDownloadButton = mileageResponse?.results?.dataItems.length > 0;

  useEffect(() => {
    const initUtagData = {
      channel: 'content',
      pageName: PAGE_TITLES["mileage"]
    };
    initAnalytics(initUtagData, 'init call', 'view')
  }, []);

  useEffect(() => {
    getMileageList(gridOptions);
    gridOptions.page > 1 ? navigate(`/app/reports/mileage?page=${gridOptions.page}`) : navigate(`/app/reports/mileage`)
  }, [gridOptions])

  const onRowClick = row => {}

  return (
    <div className={classes.mileageTab}>
      {
        userDetails?.userInfo?.providerInfo?.providerCode === AIRLINES.AA && checkPermission("F_VIEW_REPORT_AWARDS_POWERBI") ?
          <PowerBi powerBiConfig={powerBiConfig}/>
        :
          <>
            <MileageFilters
              response={mileageResponse}
              gridOptions={gridOptions}
              setGridOptions={setGridOptions}
              type="REPORTS"
              enableDownloadButton={enableDownloadButton}
            />
            <MileageGrid
              mileageResponse={mileageResponse}
              gridOptions={gridOptions}
              setGridOptions={setGridOptions}
              onRowClick={onRowClick}
            />
          </>
      }
    </div>
  )
}

export default MileageTab;
